module.exports = __webpack_public_path__ + "img/ug.5653cd84.svg";